import styled from 'styled-components'
import IMAGES from '../../images'
import { HEADER_FONT_SIZE_DESKTOP, HEADER_FONT_SIZE_TABLET } from '../../constant'

export const RegisterPageWrapper = styled.div`
  background-image: url(${IMAGES.FOOTER_LEFT}), url(${IMAGES.FOOTER_RIGHT}), linear-gradient(270deg, #00B74F -22.41%, #1D4289 108.33%);
  background-position: left bottom, right top, center;
  background-repeat: no-repeat, no-repeat;
  min-height: 100vh; 
`
export const RegisterFormWrapper = styled.div`
  max-width: 820px;
  min-height: 100vh;
  padding: 32px 0;
  margin: 0 auto;
  @media only screen and (max-width: 1024px) {
    max-width: 90%;
  }

  .ant-form-item-no-colon {
    display: none !important;
  }

  .form-item-wrapper {
    position: relative;

    label {
      position: absolute;
      top: -4px;
      left: 24px;
      z-index: 1;
      font-weight: 600;
      background: #fff;
      padding: 0 8px 0 4px;
    }
  }

  .solutions-label {
    display: block;
    margin-bottom: 12px;
    font-weight: 600;
  }

  .gradient-btn {
    background: linear-gradient(270deg, rgb(0, 183, 79) -22.41%, rgb(29, 66, 137) 108.33%);
    color: #e8e8e8;

    &:hover {
      background: linear-gradient(270deg, rgb(0, 183, 79) -22.41%, rgb(29, 66, 137) 108.33%) !important;
      color: #ffffff;
    }
  }
`
export const CloseIcon = styled.div`
  position: absolute;
  top: 32px;
  transform: translateY(-50%);
  right: 24px;
  cursor: pointer;
`
export const FormHeader = styled.div`
  position: relative;
  text-align: center;
  .register-logo {
    height: 44px;
    @media only screen and (max-width: 480px) {
      height: 28px;
    }
  }
`

export const FormBody = styled.div`
  background: #fff;
  margin-top: 40px;
  border-radius: 24px;
  padding: 48px 48px 24px 48px;
  position: relative;
  .ant-input-lg, .ant-select-selector {
    font-size: 14px !important;
  }
`
export const RegisterTitle = styled.div`
  text-align: center;
  margin-bottom: 56px;
  

  span {
    background: linear-gradient(270deg, #00B74F -22.41%, #1D4289 108.33%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-size: ${HEADER_FONT_SIZE_DESKTOP};
    margin-bottom: 40px;
    text-align: center;
    text-transform: uppercase;
    font-weight: 700;
    
    @media only screen and (max-width: 768px) {
      font-size: ${HEADER_FONT_SIZE_TABLET};
    }
  }
`